export const LOCATIONS = [
  { id: 'gym', label: 'Gimnasio', icon: '🏋️' },
  { id: 'home', label: 'Casa', icon: '🏠' },
];

export const GOALS = [
  { id: 'hypertrophy', label: 'Hipertrofia' },
  { id: 'strength', label: 'Fuerza' },
  { id: 'endurance', label: 'Resistencia' },
];

export const MUSCLE_GROUPS = [
  { id: 'glutes', label: 'Glúteo', image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&w=300&q=80' },
  { id: 'legs', label: 'Piernas', image: 'https://images.unsplash.com/photo-1434608519344-49d77a699ded?auto=format&fit=crop&w=300&q=80' },
  { id: 'upper', label: 'Torso Superior', image: 'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?auto=format&fit=crop&w=300&q=80' },
  { id: 'cardio', label: 'Cardio', image: 'https://images.unsplash.com/photo-1538805060512-e28281356391?auto=format&fit=crop&w=300&q=80' },
];

export const EXERCISES = [
  {
    id: 'hip_thrust',
    name: 'Hip Thrust',
    muscleGroup: 'glutes',
    location: ['gym'],
    videoUrl: 'https://www.youtube.com/embed/SEdqd1n0cvg?autoplay=1&mute=1&loop=1&playlist=SEdqd1n0cvg', // Example placeholder
    thumbnail: 'https://img.youtube.com/vi/SEdqd1n0cvg/sddefault.jpg',
    muscleMap: 'https://cdn.shopify.com/s/files/1/1876/4703/files/gluteus-maximus-muscle-anatomy_480x480.jpg?v=1661352462', // Placeholder anatomy
    defaults: {
      series: 4,
      reps: 12,
      rpe: 8,
      tempo: '3-0-1',
      rest: 90,
      weight: 60, // Kg
    },
    instructions: [
      'Apoya la espalda alta en el banco.',
      'Coloca la barra sobre la cadera (usa almohadilla).',
      'Empuja con los talones y contráe fuerte el glúteo arriba.',
      'Mantén la barbilla pegada al pecho.'
    ]
  },
  {
    id: 'goblet_squat',
    name: 'Goblet Squat',
    muscleGroup: 'legs',
    location: ['gym', 'home'],
    videoUrl: 'https://www.youtube.com/embed/MeIiIdhvQnE?autoplay=1&mute=1&loop=1',
    thumbnail: 'https://img.youtube.com/vi/MeIiIdhvQnE/sddefault.jpg',
    muscleMap: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Quadriceps_femoris_muscle_anterior_labeled.png/640px-Quadriceps_femoris_muscle_anterior_labeled.png',
    defaults: {
      series: 3,
      reps: 15,
      rpe: 7,
      tempo: '2-0-1',
      rest: 60,
      weight: 12, // Kg
    },
    instructions: [
      'Sostén la mancuerna pegada al pecho.',
      'Baja profundo manteniendo la espalda recta.',
      'Las rodillas deben seguir la línea de los pies.'
    ]
  },
  {
    id: 'push_up',
    name: 'Flexiones (Push Ups)',
    muscleGroup: 'upper',
    location: ['gym', 'home'],
    videoUrl: 'https://www.youtube.com/embed/IODxDxX7oi4',
    thumbnail: 'https://img.youtube.com/vi/IODxDxX7oi4/sddefault.jpg',
    muscleMap: 'https://upload.wikimedia.org/wikipedia/commons/e/e3/Pectoralis_major.png',
    defaults: {
      series: 4,
      reps: 10,
      rpe: 9,
      tempo: '2-1-1',
      rest: 60,
      weight: 0, // Bodyweight
    },
    instructions: [
      'C cuerpo en línea recta desde cabeza a talones.',
      'Baja hasta que el pecho casi toque el suelo.',
      'Codos a 45 grados del cuerpo.'
    ]
  }
];

// Helper to generate a simple routine
export function generateRoutine({ location, focus }) {
  // Simple filter logic mimicking the "Excel" backend
  const exercises = EXERCISES.filter(ex => 
    ex.muscleGroup === focus && ex.location.includes(location)
  );
  
  // If no specific match, return a fallback or random selection to ensure UI works
  if (exercises.length === 0) {
    // Fallback logic for demo purposes
    return EXERCISES.slice(0, 2); 
  }
  
  return exercises; 
}
